export default __webpack_public_path__ + "static/media/baseball-player-copy.4bd15c95.png";